import { render } from "./B2bFilterButtonBorradores.vue?vue&type=template&id=340c14d9&scoped=true&lang=pug"
import script from "./B2bFilterButtonBorradores.vue?vue&type=script&lang=js"
export * from "./B2bFilterButtonBorradores.vue?vue&type=script&lang=js"

import "./B2bFilterButtonBorradores.vue?vue&type=style&index=0&id=340c14d9&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-340c14d9"]])

export default __exports__